import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  AuthedLayout,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
} from '../../../components';
import Apis from '../../../apis';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { Nullable } from '../../../types';
import { PHIWH, StudentWH, UserInfo } from '../../../model';
import {
  Row,
  Table,
  Container,
  Button,
  Col,
  FormControl,
  Dropdown,
  DropdownButton,
} from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { ClassSem, WrapClassBaseLayout } from '../../../layouts';
import { ApplicationState } from '../../../redux/States';
import { WHPropertyFields, WHTableHeader } from './../../TableHeaders/WHHeader';
import { semesterRange } from '../../../utils/date';
import { useSemGrade } from '../../../hook';
import {
  SheetHeaderDisplay,
  downloadDataAsExcel,
  printDataAsTable,
} from '../../../utils';
import { SightContext } from '../../TableHeaders/SightHeader';

type MetricPageData = StudentWH & Nullable<PHIWH>;

const displayHeader: (SheetHeaderDisplay<MetricPageData> &
  HeaderDisplayKeysWithType<MetricPageData>)[] = [
    { property: 'pid', display: '統編' },
    { property: 'name', display: '學生' },
    {
      display: '性別',
      property: 'sex',
      onRender: (v) => (v === '1' ? '男' : '女'),
    },
    { property: 'grade', display: '年級' },
    {
      property: 'className',
      display: '班級'
    },
    { property: 'seat', display: '座號' },
    { property: 'height', display: '身高' },
    { property: 'weight', display: '體重' },
    { display: 'BMI', property: 'bmi' },
  ];

const mapState = (state: ApplicationState, ownProps: ClassSem) => ({
  ...ownProps,
  ...state.auth,
});
const mapDispatch = { ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;

const wHCantCheck: FunctionComponent<Props> = ({
  user,
  catchErrorForModal,
}) => {

  const { currentSemester = '', semesters = {} } = user || {};
  const [currentSem, setCurrentSem] = useState(currentSemester);
  const { year = -1, sem = -1 } = semesters[currentSem];

  const { yearSem, element: semGradeElement } = useSemGrade();
  const [students, setStudent] = useState([] as MetricPageData[]);
  const [inputing, setInputing] = useState(false);
  const [editingStudent, setEditingStudent] = useState<MetricPageData>();
  const [userinfo, setUser] = useState<UserInfo>();
  useEffect(() => {
    if (yearSem) {
      Apis.getUserInfo()
        .then((u) => {
          setUser(u);
        })
        .catch(catchErrorForModal);

      toast
        .promise(
          Apis
            .getClassStudentCantCheck(yearSem.year, yearSem.sem)
            .then((metrics) => {
              const datas: MetricPageData[] = metrics.map((m) => {
                const latestMetric =
                  m.phiWHs.length > 0
                    ? m.phiWHs.find((cv) => cv.year === year && cv.sem === sem)
                    : undefined;
                return {
                  ...m,
                  ...latestMetric,
                };
              });
              setStudent(datas);
            }),
          {
            pending: '資料載入中......',
            success: '資料載入成功！',
            error: '資料載入失敗！請查看錯誤資訊。',
          }
        )
        .catch(catchErrorForModal);


    } else {
      setStudent([]);
    }
  }, [yearSem?.year, yearSem?.sem, inputing]);

  return (
    <AuthedLayout>
      <Row className="justify-content-between">
        <Col>
          <Row>
            <Col xs={3} className="mr-3">
              {semGradeElement}
            </Col>
          </Row>
        </Col>
        <div>
          <DropdownButton
            id="wh-cant-check-export"
            title="匯出"
            variant="success"
            disabled={!students.length}
          >
            <Dropdown.Item
              onClick={() => {
                downloadDataAsExcel({
                  title:
                    `${user.schools[user.currentSchool].name}` +
                    `${yearSem?.year}學年` +
                    `${yearSem?.sem}學期_生長發育無法測量名單`,
                  values: students,
                  headers: displayHeader,
                  context: SightContext,
                  footer:
                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                  exportfile: userinfo?.exportFileType,
                });
              }}
            >
              Excel 下載
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() => {
                printDataAsTable({
                  title:
                    `${user.schools[user.currentSchool].name}` +
                    `${yearSem?.year}學年` +
                    `${yearSem?.sem}學期_生長發育無法測量名單`,
                  values: students,
                  headers: displayHeader,
                  context: SightContext,
                  footer:
                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                });
              }}
            >
              列印
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </Row>
      <hr />
      <Row>
        <EditableTableDiv
          headers={displayHeader}
          values={students}
          context={SightContext}
        />
      </Row>
    </AuthedLayout>
  );
};

export const WHCantCheck = connector(wHCantCheck);
